import React, { ReactNode, useRef, useEffect, useCallback } from 'react';

// cSpell:words unmount

/* eslint-disable @typescript-eslint/no-unnecessary-type-arguments */

interface Props {
    children: ReactNode;
    className?: string;
    onDragEnter?(): void;
    onDragLeave?(): void;
    onDropFiles(files: FileList): void;
}

const DropZone = ({ children, className, onDragEnter, onDragLeave, onDropFiles }: Props) => {
    const rootRef = useRef<HTMLDivElement | null>(null);

    const handleDragEnter = useCallback((event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (onDragEnter) {
            onDragEnter();
        }
    }, [onDragEnter]);

    const handleDragLeave = useCallback((event: DragEvent) => {
        if (onDragLeave) {
            onDragLeave();
        }
        event.preventDefault();
        event.stopPropagation();
    }, [onDragLeave]);

    const handleDropFiles = useCallback((event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer?.files.length) {
            onDropFiles(event.dataTransfer.files);
        }
    }, [onDropFiles]);

    const handleDragOver = useCallback((event: DragEvent) => {
        event.preventDefault();
    }, []);

    useEffect(() => {
        const node = rootRef.current;
        if (!node) return;

        node.addEventListener('dragenter', handleDragEnter, false);
        node.addEventListener('dragover', handleDragOver, false);
        node.addEventListener('dragleave', handleDragLeave, false);
        node.addEventListener('drop', handleDropFiles, false);

        return () => {
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('dragleave', handleDragLeave);
            node.removeEventListener('drop', handleDropFiles);
        };
    }, [handleDragEnter, handleDragLeave, handleDropFiles, handleDragOver]);

    return (
        <div className={className} ref={rootRef}>
            {children}
        </div>
    );
};

export default DropZone;
